import { IAction } from '~/src/store';

import { IPaymentCredit } from '../reducers';

import { EPaymentActions } from './index';

export type TSetCredits = IAction<EPaymentActions.SET_CREDITS, IPaymentCredit[]>;

const setCredits = (credits: IPaymentCredit[]): TSetCredits => ({
    type: EPaymentActions.SET_CREDITS,
    payload: credits,
});

export default setCredits;

